import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Dropdown } from 'react-bootstrap';
import Icon2 from 'components/media/Icon2/index.js';
import cx from 'utils/cx.js';
import ConsentIcon from './ConsentIcon.jsx';
import messages from './messages.js';

function ConsentControl(props) {
  const { item, onChange } = props;
  const { id, consent } = item;
  const [working, setWorking] = useState(false);
  if (!onChange) {
    return <ConsentIcon value={consent} className="fs-3" />;
  }
  async function handleChange(newConsent) {
    setWorking(true);
    await onChange(id, newConsent);
    setWorking(false);
  }
  const classList = cx('d-inline-flex align-items-baseline', working && 'opacity-50');
  return (
    <div className={classList}>
      <ConsentIcon value={consent} className="fs-3" />
      <Dropdown id={`edit-${id}`} align="end" className="no-caret">
        <Dropdown.Toggle variant="link" className="py-0">
          <Icon2 className="ss-draw text-primary fs-4 opacity-50" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item eventKey="1" onClick={() => handleChange(true)}>
            <ConsentIcon value className="me-3 fs-4" />
            <FormattedMessage {...messages.consent} />
          </Dropdown.Item>
          <Dropdown.Item eventKey="2" onClick={() => handleChange(false)}>
            <ConsentIcon value={false} className="me-3 fs-4" />
            <FormattedMessage {...messages.noConsent} />
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

ConsentControl.propTypes = {
  item: PropTypes.object,
  onChange: PropTypes.func,
};

export default ConsentControl;
